
import { Component, Inject } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { PORTAL_DATA } from '../../../services/overlay.service';

@Component({
	selector: 'bb-color-panel',
	templateUrl: './bb-color-panel.component.html',
	styleUrls: ['./bb-color-panel.component.scss']
})
export class BbColorPanelComponent {
	public color: string;

	private closeColorPickerSubject: Subject<string>;
	private changeColorSubject: Subject<string>;

	private backdropClickSubject: Subject<void>;
	private backdropClickSubscription: Subscription;

	private inputChangedColorSubject: Subject<string>;
	private inputChangedColorSubscription: Subscription;

	constructor(@Inject(PORTAL_DATA) public data: any) {
		this.closeColorPickerSubject = data.closeColorPickerSubject;
		this.changeColorSubject = data.changeColorSubject;
		this.inputChangedColorSubject = data.inputChangedColorSubject;
		this.backdropClickSubject = data.backdropClickSubject;

		if (this.inputChangedColorSubject) {
			this.inputChangedColorSubscription = this.inputChangedColorSubject.subscribe((color) => this.color = color);
		}

		if (this.backdropClickSubject) {
			this.backdropClickSubscription = this.backdropClickSubject.subscribe(() => this.closeColorPicker());
		}
	}

	onColorChange() {
		if (this.changeColorSubject) {
			this.changeColorSubject.next(this.color);
		}
	}

	closeColorPicker() {
		if (this.inputChangedColorSubscription) {
			this.inputChangedColorSubscription.unsubscribe();
		}
		if (this.backdropClickSubscription) {
			this.backdropClickSubscription.unsubscribe();
		}
		if (this.closeColorPickerSubject) {
			this.closeColorPickerSubject.next(this.color);
		}
	}
}
